import React, { useRef } from 'react';
import { ColumnInstance } from 'react-table';

import { Tr, Td, TableRowProps, TableCellProps } from '@chakra-ui/react';

import { Input } from 'types/input';

import { Row, Cell } from './types';

interface RowProps {
  visibleColumns: ColumnInstance<Input>[];
  renderRowSubComponent: (params: { parentId: number }) => React.ReactElement;
  row: Row;
}

const InputsTableRow: React.FC<RowProps> = ({
  visibleColumns,
  renderRowSubComponent,
  row,
  ...restProps
}) => {
  const ref = useRef<HTMLTableRowElement>(null);

  function isExpandable(tableRow: Row): boolean {
    return !!tableRow.original._source.has_children;
  }

  function getCustomRowExpandedProps(tableRow: Row): TableRowProps {
    return {
      ...row.getToggleRowExpandedProps(),
      title: 'Ver marcas e detalhes',
      backgroundColor: tableRow.isExpanded ? 'brand.500' : 'inherit',
      color: tableRow.isExpanded ? 'white' : 'gray.800',
      _hover: {
        color: tableRow.isExpanded ? 'white' : 'gray.800',
        backgroundColor: tableRow.isExpanded ? 'brand.500' : 'gray.200',
      },
    };
  }

  const getCustomCellProps = (cell: Cell): TableCellProps => {
    return {
      onClick: (e) => {
        e.stopPropagation();
        if (cell.column.id !== 'actions') {
          row.toggleRowExpanded();
        }
      },
    };
  };

  return (
    <>
      <Tr
        ref={ref}
        {...row.getRowProps()}
        {...(isExpandable(row) && getCustomRowExpandedProps(row))}
        {...restProps}
      >
        {row.cells.map((cell) => {
          return (
            <Td
              {...cell.getCellProps()}
              {...(isExpandable(row) && getCustomCellProps(cell))}
              isNumeric={cell.column.isNumeric}
              borderBottomColor={row.isExpanded ? 'brand.400' : undefined}
              py={4}
            >
              {cell.render('Cell')}
            </Td>
          );
        })}
      </Tr>

      {row.isExpanded ? (
        <Tr
          backgroundColor={row.isExpanded ? 'brand.100' : 'inherit'}
          border="1px solid white"
          sx={{
            '* > table': {
              backgroundColor: 'white',
              borderBottom: 'none',
            },
          }}
        >
          <Td colSpan={visibleColumns.length} paddingY={4} borderBottom="none">
            {isExpandable(row) &&
              renderRowSubComponent({
                parentId: Number(row.original._id),
              })}
          </Td>
        </Tr>
      ) : null}
    </>
  );
};

export default InputsTableRow;
